import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import transactionReducer from './slices/transactionSlice';
import userReducer from './slices/userSlice';
import webhookReducer from './slices/webhookSlice';
import ipWhitelistReducer from './slices/ipWhitelistSlice';
import uiReducer from './slices/uiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    transactions: transactionReducer,
    users: userReducer,
    webhooks: webhookReducer,
    ipWhitelist: ipWhitelistReducer,
    ui: uiReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});
